import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell } from '@material-ui/core';
import classNames from 'classnames';
import _ from 'lodash';

import { RaceCompetitor } from 'src/interfaces/RacingState';
import useIsMobile from '../../../../../hooks/useIsMobile';

interface BetHorseCellsDesktopProps {
  onClick: (e) => void, // eslint-disable-line no-unused-vars
  competitor: RaceCompetitor,
  formatName?: (name: string) => string, // eslint-disable-line no-unused-vars
  shouldWeight: boolean,
  shouldJockey: boolean,
  official: boolean
}

export default function BetHorseCellsDesktop({
  onClick,
  competitor,
  shouldWeight,
  shouldJockey,
  official
}: BetHorseCellsDesktopProps) {
  const { t } = useTranslation('common');
  const mobile = useIsMobile();

  return (
    <>
      <TableCell onClick={ onClick }>
        <div className={
          classNames({
            'competitors-table__horse-details': true,
            'competitors-table__horse-details--scratched': competitor?.statusNumber > 1
          })
        }
        >
          {
            shouldWeight && !official &&
            <>
              <div className="competitors-table__value competitors-table__value--highlighted">
                {
                  (!_.isNull(competitor?.weight) && competitor?.weight !== 0)
                  && t('racingDetail.weight', { weight: competitor.weight }) || '-'
                }
              </div>
              <div className="competitors-table__value">
                { competitor?.horse?.age ? t('racingDetail.age', { age: competitor?.horse?.age }) : '-' }
                { mobile ? (competitor?.horse?.gender ? competitor?.horse?.gender : '-') : '' }
              </div>
            </>
          }
        </div>
      </TableCell>
      <TableCell onClick={ onClick }>
        <div className={
          classNames({
            'competitors-table__horse-details': true,
            'competitors-table__horse-details--scratched': competitor?.statusNumber > 1
          })
        }
        >
          {
            shouldJockey && !official &&
              <>
                <div className="competitors-table__value competitors-table__value--highlighted">
                  { competitor?.jockey && `${ competitor?.jockey?.name || '-' }` }
                </div>
                <div className="competitors-table__value">
                  { competitor?.trainer?.name && `${ competitor?.trainer?.name }` || '-' }
                </div>
              </>
          }
        </div>
      </TableCell>
    </>
  );
}
